import { render, staticRenderFns } from "./user.vue?vue&type=template&id=4aea8fd0&scoped=true&"
import script from "./user.vue?vue&type=script&lang=ts&"
export * from "./user.vue?vue&type=script&lang=ts&"
import style0 from "./user.vue?vue&type=style&index=0&id=4aea8fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea8fd0",
  null
  
)

export default component.exports